import React, { useContext } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useWindowSize } from "@/hooks/useIsMobile";
import { useRouter } from "next/router";
const CandidateProfile = ({
  electionPassedCategory = "",
  masterKey = "",
  candidateProfileData = null,
  candidateList = null,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const showCandidateProfile = electionKeys?.showCandidateProfile;
const keyCandiShowArrow = electionKeys?.keyCandiShowArrow;
  const election_year = electionKeys?.electionYear;

//  console.log("candidateProfileData", candidateProfileData);
  
  const { width: screenWidth } = useWindowSize();
const router = useRouter();
  const isDelhi = router?.asPath.includes("delhi");
  const isBihar = router?.asPath.includes("bihar");
  const isMaharashtra = router?.asPath.includes("maharashtra");
  const isHaryana = router?.asPath.includes("haryana");
  const isJharkhand = router?.asPath.includes("jharkhand");
  return   candidateProfileData ? (
    <div className="mx-2 my-2">
      <div className="flex items-center">
        <span className={`w-[5px] h-[45px] md:h-[30px] ${isBihar ? "bg-[#CF4C9B]" :'bg-primary'}`}></span>
        <h1 className="text-xl font-bold ml-2">
          {/* {candidateProfileData?.candidate_h} Election Result {election_year}{" "}
          {candidateList?.constituency_name} */}
         {candidateProfileData?.candidate_h} {candidateList?.constituency_name_h} विधानसभा रिजल्ट {election_year}
        </h1>
      </div>

      {/* Profile Section */}
      <div className="shadow-md rounded-md mt-3">
        <div className="flex items-center  bg-gradient-to-b to-blue-100 from-white shadow-md  rounded-md p-6">
          {/* Profile Picture */}
          <div className="w-20 h-20 bg-gray-200 rounded-full flex justify-center items-center text-gray-500 overflow-hidden">
            {candidateProfileData?.image ? (
              <img
                className="w-full h-full rounded-full object-cover"
                alt="partylogo"
                src={candidateProfileData?.image}
              />
            ) : (
              <span className="text-2xl">👤</span>
            )}
          </div>

          {/* Details */}
          <div className="ml-4">
            <h2 className="text-xl font-semibold">
              {candidateProfileData?.candidate_h}
            </h2>
            <p className="text-gray-600 flex items-center">
              {/* बीजेपी{" "} */}
              {candidateProfileData?.party_h}
              <img
                className="bg-gradient-to-b to-blue-100 ml-2 rounded-full"
                width={25}
                height={25}
                alt="partylogo"
                src={candidateProfileData?.party_logo}
              />
              {/* <span className="ml-2 text-orange-500">🌼</span> */}
            </p>
         {  keyCandiShowArrow ? <p className=" font-semibold flex items-center">
              {candidateProfileData?.status === "WON" ? (
                <p className="flex items-center text-green-500">
                  {" "}
                  <img
                    width={20}
                    height={20}
                    src={
                      "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                    }
                    alt="Live Icon"
                  />{" "}
                  <span className="ml-1 mt-1"> जीत</span>{" "}
                </p>
              ) : candidateProfileData?.status === "LEADING" ? (
                <p className="flex items-center text-black-500 justify-center">
                  <img
                    width={20}
                    height={20}
                    src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/arrow-up.png"
                    alt="Live Icon"
                  />
                  <span className="ml-1">आगे</span>
                </p>
              ) : candidateProfileData?.status === "Result Awaited" ? (
                <p className="flex items-center text-black-500 justify-center">
                  <img
                    width={20}
                    height={20}
                    src="/assets/liveIcon.gif"
                    alt="Live Icon"
                  />
                  <span className="ml-1">Result Awaited</span>
                </p>
              ) : candidateProfileData?.status === "TRAILING" ? (
                <p className="flex items-center text-black-500 justify-center">
                  <img
                    width={20}
                    height={20}
                    src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/arrow-down.png"
                    alt="Live Icon"
                  />
                  <span className="ml-1">पीछे</span>
                </p>
              ) : (
                <p className="flex items-center text-[#CF4C9B] justify-center">
                  <img
                    width={20}
                    height={20}
                    src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                    alt="Live Icon"
                  />
                  <span className="ml-1">हार</span>
                </p>
                 
              )}

              {!candidateProfileData?.status === "Result Awaited" && (
                <span className="ml-2">
                  <img
                    className="bg-gradient-to-b to-blue-100"
                    width={15}
                    height={15}
                    alt="partylogo"
                    src={
                      candidateProfileData?.status === "LEADING"
                        ? "/assets/icons/svg/up-arrow.png"
                        : candidateProfileData?.status_logo
                    }
                  />
                </span>
              )}
            </p>  :<p className="font-semibold flex items-center">
                  <img
                    width={20}
                    height={20}
                    src="/assets/liveIcon.gif"
                    alt="Live Icon"
                  />
                  <span className="ml-1">Result Awaited</span>
                </p>}
          </div>
        </div>

        {/* Details Table */}
        <div className="overflow-x-auto bg-white shadow-md">
          <table className="w-full text-sm text-gray-700">
            <tbody>
              {/* Row 1 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2  font-bold w-1/2 md:w-[20%]">आयु</td>
                <td className="py-3 px-2 w-1/2 md:w-[30%]">
                  {candidateProfileData?.age} वर्ष
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-[20%]">वोट</td>
                <td className="py-3 px-2 w-1/2 md:w-[30%]">
                  {keyCandiShowArrow ? candidateProfileData?.votes :"-"}{" "}
                </td>
              </tr>
              {/* Row 2 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">लिंग</td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
                  {["M", "MALE", "Male", "male"].includes(
                    candidateProfileData?.gender
                  )
                    ? "पुरुष"
                    : ["F", "FEMALE", "Female", "female"].includes(
                        candidateProfileData?.gender
                      )
                    ? "महिला"
                    : candidateProfileData?.gender}{" "}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">
                  संपत्ति
                </td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
               {candidateProfileData?.assets && `₹ ${candidateProfileData?.assets}`}
                </td>
              </tr>
              {/* Row 3 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">
                  शैक्षिक योग्यता
                </td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
                  {" "}
                  {candidateProfileData?.qualification}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">
                  कुल आय
                </td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
                 {candidateProfileData?.income && `₹ ${candidateProfileData?.income}`}
                </td>
              </tr>
              {/* Row 4 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  प्रोफेशनल व्यवसाय
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateProfileData?.profession}{" "}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  अचल संपत्ति
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
               { candidateProfileData?.immovable_assets&&`₹ ${candidateProfileData?.immovable_assets}`}
                </td>
              </tr>
              {/* Row 5 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  आपराधिक मामले
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateProfileData?.criminal_cases}{" "}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  निर्वाचन क्षेत्र
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateList?.constituency_name_h || candidateList?.constituency_name}{" "}
                </td>
              </tr>
              {/* Row 6 */}
              <tr className="flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  देनदारियां
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                {candidateProfileData?.liabilities &&  `₹ ${candidateProfileData?.liabilities}`}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  चल संपत्ति
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                 {candidateProfileData?.moveable_assets&& `₹ ${candidateProfileData?.moveable_assets}`}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Related Candidates Section */}
      <div className="bg-white shadow-md rounded-md p-2 my-1">
        <div className="flex justify-between items-center">
          <div className="flex items-center ">
            {/* Vertical line */}
            <span className={`  ${isBihar ? "bg-[#CF4C9B]" :'bg-primary'} w-[5px] h-[30px]  inline-block mr-1`}></span>
            <h2 className=" font-bold  text-[20px]">
              {candidateList?.constituency_name?.charAt(0).toUpperCase()+ candidateList?.constituency_name?.slice(1)?.toLowerCase()} Constituency Candidates Names
              
            </h2>
          </div>

          {/* Link */}
          <a
            className={` ${isBihar ? "text-[#CF4C9B]" :'text-primary'} text-sm font-medium whitespace-nowrap `}
            href={`${process?.env?.NEXT_PUBLIC_WEBSITE_URL}/elections/${electionPassedCategory}/constituency-list`}
          >
            और देखें &gt;
          </a>
        </div>

        <div
          className={`flex gap-4 overflow-x-auto mt-4`} // Flex layout with horizontal scroll
          style={{
            paddingBottom: "1rem", // Extra padding for better scroll spacing
          }}
        >
          {candidateList?.candidate
            ?.filter(
              (can) =>
                can?.id !== candidateProfileData?.id &&
                can?.candidate !== "NOTA" &&
                can?.candidate !== "Nota" &&
                can?.candidate !== "nota"
            )
            // ?.slice(0, screenWidth < 768 ? 4 : candidateList?.candidate?.length) // Show up to 5 cards on desktop
            ?.map((can, index) => (
              <div
                onClick={
                  () =>
                    (window.location.href = `${
                      process?.env?.NEXT_PUBLIC_WEBSITE_URL
                    }/elections/${electionPassedCategory}/candidates/${can?.candidate

                      ?.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}-result-${candidateList?.constituency_name
                      ?.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}-${candidateList?.id}-${can?.id}`) //use candidate id
                }
                key={index}
                className="  flex flex-col items-center bg-gradient-to-b to-blue-100 from-white p-4 rounded-md shadow-sm"
                style={{
                  cursor: "pointer",
                  flexShrink: 0, // Prevent shrinking for scrolling
                  width: screenWidth >= 768 ? "25%" : "45%", // Adjust card width based on screen size
                }}
              >
                <div className="w-20 h-20 bg-gray-200 rounded-full flex justify-center items-center text-gray-500 overflow-hidden">
                  {can?.image ? (
                    <img
                      className="w-full h-full rounded-full object-cover"
                      alt="partylogo"
                      src={can?.image}
                    />
                  ) : (
                    <span className="text-2xl">👤</span>
                  )}
                </div>

                <div className="text-center">
                  {" "}
                  <p className={`mt-2 text-sm underline font-medium    ${isBihar ? "hover:text-[#CF4C9B]" :'hover:text-primary '} `}>
                    {can?.candidate_h}
                  </p>
                  <p className="text-sm text-gray-600">{can?.party_h}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* ADR START */}
      <div
        onClick={() => window.open("https://adrindia.org/", "_blank")}
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          marginTop: "20px",
          marginBottom: "20px",
          cursor: "pointer",
        }}
      >
        <div>
          {" "}
          <img src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/adr_logo.png" />{" "}
        </div>
        <div>
          <img src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/mynetainfo.png" />{" "}
        </div>
        <div className="hover:underline">
          Association for Democratic Reforms (ADR) | MyNeta.info.
        </div>
      </div>
      {/* ADR END */}
    </div>
  ) : (
    <div className="text-center"> No data found</div>
  );
};

export default CandidateProfile;
